import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { InsurancePayment } from '../../../models/quotation-model/catalogs/insurance-payment.model';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class InsurancePaymentService {
  URL_API = environment.apiURL;
  constructor(private http: HttpClient) {}

  getInsurancePayments(): Observable<InsurancePayment[]> {
    return this.http.get<InsurancePayment[]>(this.URL_API + '/InsurancePayment');
  }
}
